module.exports = __webpack_public_path__ + "img/sankaku_23_red.e19a274b.png";